import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import api from '../services/api';

const AuthContext = createContext({});

export function AuthProvider({ children }) {
  const [data, setData] = useState(() => {
    const token = localStorage.getItem('@Uadmin:token');
    const user = localStorage.getItem('@Uadmin:user');

    if (token && user) {
      api.defaults.headers.authorization = `Bearer ${token}`;

      return { token, user };
    }

    return {};
  });

  const signIn = useCallback(async ({ username, password }) => {
    const response = await api.post('sessions/admins', {
      user: username,
      password,
    });

    const { token } = response.data;

    localStorage.setItem('@Uadmin:token', token);
    localStorage.setItem('@Uadmin:user', username);

    api.defaults.headers.authorization = `Bearer ${token}`;

    setData({ token, user: username });
  }, []);

  const signOut = useCallback(() => {
    localStorage.removeItem('@Uadmin:token');
    localStorage.removeItem('@Uadmin:user');

    setData({});
  }, []);

  const updateUser = useCallback(user => {
    localStorage.setItem('@Uadmin:user', JSON.stringify(user));

    setData(state => ({
      token: state.token,
      user,
    }));
  }, []);

  const memo = useMemo(
    () => ({ user: data.user, signIn, signOut, updateUser }),
    [data.user, signIn, signOut, updateUser]
  );
  return <AuthContext.Provider value={memo}>{children}</AuthContext.Provider>;
}

export const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
};
